import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock, ShieldCheck, ArrowRight } from 'lucide-react';
export function ContactPage() {
  return <>
      {/* Hero */}
      <section className="bg-olive py-16 md:py-20" data-id="element-762">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-763">
          <div className="text-center max-w-3xl mx-auto" data-id="element-764">
            <span className="text-gold font-bold uppercase tracking-widest text-xs mb-4 block" data-id="element-765">
              GET IN TOUCH
            </span>
            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 leading-tight" data-id="element-766">
              Contact <span className="italic text-cream" data-id="element-767">Us</span>
            </h1>
            <p className="text-white/80 text-base md:text-lg font-medium" data-id="element-768">
              Ready to take the first step? Reach out to schedule a
              consultation.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Content */}
      <section className="py-16 lg:py-20 bg-cream" data-id="element-769">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-770">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12" data-id="element-771">
            {/* Form */}
            <div data-id="element-772">
              <div className="bg-olive rounded-2xl p-6 md:p-8" data-id="element-773">
                <div className="flex items-center gap-2 text-gold mb-6 text-sm font-bold uppercase tracking-wide" data-id="element-774">
                  <ShieldCheck size={18} data-id="element-775" />
                  HIPAA-Compliant Secure Form
                </div>
                <form className="space-y-4" onSubmit={e => e.preventDefault()} data-id="element-776">
                  <div data-id="element-777">
                    <label htmlFor="fullName" className="block text-sm font-bold text-white/80 mb-1.5 uppercase tracking-wide" data-id="element-778">
                      Full Name
                    </label>
                    <input type="text" id="fullName" className="w-full px-4 py-3 rounded-lg border border-white/20 bg-white/10 focus:border-gold focus:ring-1 focus:ring-gold/30 outline-none transition-all min-h-[44px] font-medium text-white text-base placeholder-white/30" required data-id="element-779" />
                  </div>
                  <div data-id="element-780">
                    <label htmlFor="email" className="block text-sm font-bold text-white/80 mb-1.5 uppercase tracking-wide" data-id="element-781">
                      Email Address
                    </label>
                    <input type="email" id="email" className="w-full px-4 py-3 rounded-lg border border-white/20 bg-white/10 focus:border-gold focus:ring-1 focus:ring-gold/30 outline-none transition-all min-h-[44px] font-medium text-white text-base placeholder-white/30" required data-id="element-782" />
                  </div>
                  <div data-id="element-783">
                    <label htmlFor="phone" className="block text-sm font-bold text-white/80 mb-1.5 uppercase tracking-wide" data-id="element-784">
                      Phone Number
                    </label>
                    <input type="tel" id="phone" className="w-full px-4 py-3 rounded-lg border border-white/20 bg-white/10 focus:border-gold focus:ring-1 focus:ring-gold/30 outline-none transition-all min-h-[44px] font-medium text-white text-base placeholder-white/30" data-id="element-785" />
                  </div>
                  <div data-id="element-786">
                    <label htmlFor="service" className="block text-sm font-bold text-white/80 mb-1.5 uppercase tracking-wide" data-id="element-787">
                      Service of Interest
                    </label>
                    <select id="service" className="w-full px-4 py-3 rounded-lg border border-white/20 bg-white/10 focus:border-gold focus:ring-1 focus:ring-gold/30 outline-none transition-all min-h-[44px] font-medium text-white text-base" data-id="element-788">
                      <option value="" className="text-charcoal" data-id="element-789">
                        Select a service...
                      </option>
                      <option value="individual" className="text-charcoal" data-id="element-790">
                        Individual Counselling
                      </option>
                      <option value="couples" className="text-charcoal" data-id="element-791">
                        Couples Therapy
                      </option>
                      <option value="family" className="text-charcoal" data-id="element-792">
                        Family Therapy
                      </option>
                      <option value="trauma" className="text-charcoal" data-id="element-793">
                        Trauma Therapy
                      </option>
                      <option value="emdr" className="text-charcoal" data-id="element-794">
                        EMDR Therapy
                      </option>
                      <option value="consultation" className="text-charcoal" data-id="element-795">
                        Free Consultation
                      </option>
                    </select>
                  </div>
                  <div data-id="element-796">
                    <label htmlFor="message" className="block text-sm font-bold text-white/80 mb-1.5 uppercase tracking-wide" data-id="element-797">
                      Message (Optional)
                    </label>
                    <textarea id="message" rows={4} className="w-full px-4 py-3 rounded-lg border border-white/20 bg-white/10 focus:border-gold focus:ring-1 focus:ring-gold/30 outline-none transition-all resize-none font-medium text-white text-base placeholder-white/30" placeholder="Please do not include sensitive medical information." data-id="element-798"></textarea>
                  </div>
                  <button type="submit" className="w-full bg-gold hover:bg-gold/90 text-white px-6 py-3.5 rounded-lg font-bold text-base transition-all shadow-soft min-h-[48px] uppercase tracking-wide" data-id="element-799">
                    Request Appointment
                  </button>
                </form>
              </div>
            </div>

            {/* Info */}
            <div className="flex flex-col justify-center space-y-8" data-id="element-800">
              <div data-id="element-801">
                <h2 className="font-heading text-xl font-bold text-charcoal mb-5" data-id="element-802">
                  Contact Information
                </h2>
                <div className="space-y-5" data-id="element-803">
                  <div className="flex items-start gap-3" data-id="element-804">
                    <div className="w-10 h-10 rounded-lg bg-olive/10 flex items-center justify-center text-olive flex-shrink-0" data-id="element-805">
                      <Phone size={18} data-id="element-806" />
                    </div>
                    <div data-id="element-807">
                      <p className="font-bold text-charcoal mb-0.5 uppercase tracking-wide text-sm" data-id="element-808">
                        Phone
                      </p>
                      <a href="tel:5489000692" className="text-charcoal/80 hover:text-olive transition-colors font-medium text-base" data-id="element-809">
                        548-900-0692
                      </a>
                    </div>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-810">
                    <div className="w-10 h-10 rounded-lg bg-olive/10 flex items-center justify-center text-olive flex-shrink-0" data-id="element-811">
                      <Mail size={18} data-id="element-812" />
                    </div>
                    <div data-id="element-813">
                      <p className="font-bold text-charcoal mb-0.5 uppercase tracking-wide text-sm" data-id="element-814">
                        Email
                      </p>
                      <a href="mailto:esther@esthermensahcounselling.com" className="text-charcoal/80 hover:text-olive transition-colors font-medium text-base break-all" data-id="element-815">
                        esther@esthermensahcounselling.com
                      </a>
                    </div>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-816">
                    <div className="w-10 h-10 rounded-lg bg-olive/10 flex items-center justify-center text-olive flex-shrink-0" data-id="element-817">
                      <MapPin size={18} data-id="element-818" />
                    </div>
                    <div data-id="element-819">
                      <p className="font-bold text-charcoal mb-0.5 uppercase tracking-wide text-sm" data-id="element-820">
                        Office Location
                      </p>
                      <p className="text-charcoal/80 font-medium text-base" data-id="element-821">
                        370 Queens Avenue, London, Ontario
                      </p>
                      <div className="mt-1.5 inline-flex items-center gap-1.5 text-xs font-bold text-olive bg-olive/10 px-2.5 py-1 rounded-full tracking-wide" data-id="element-822">
                        <span className="w-1.5 h-1.5 rounded-full bg-olive animate-pulse" data-id="element-823" />
                        Telehealth Available Across Ontario
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="pt-6 border-t border-charcoal/10" data-id="element-824">
                <div className="flex items-center gap-2 mb-4" data-id="element-825">
                  <Clock className="text-gold" size={20} data-id="element-826" />
                  <h3 className="font-heading text-base font-bold text-charcoal" data-id="element-827">
                    Office Hours
                  </h3>
                </div>
                <ul className="space-y-2 text-charcoal/80 font-medium text-base" data-id="element-828">
                  <li className="flex justify-between" data-id="element-829">
                    <span data-id="element-830">Monday - Thursday</span>
                    <span className="font-bold" data-id="element-831">9:00 AM - 6:00 PM</span>
                  </li>
                  <li className="flex justify-between" data-id="element-832">
                    <span data-id="element-833">Friday</span>
                    <span className="font-bold" data-id="element-834">9:00 AM - 3:00 PM</span>
                  </li>
                  <li className="flex justify-between" data-id="element-835">
                    <span data-id="element-836">Saturday - Sunday</span>
                    <span className="font-bold text-charcoal/40" data-id="element-837">Closed</span>
                  </li>
                </ul>
              </div>

              {/* Map Placeholder */}
              <div className="bg-olive/10 rounded-2xl p-8 text-center border border-olive/15" data-id="element-838">
                <MapPin size={32} className="text-olive mx-auto mb-3" data-id="element-839" />
                <h3 className="font-heading text-base font-bold text-charcoal mb-2" data-id="element-840">
                  370 Queens Avenue
                </h3>
                <p className="text-charcoal/60 text-sm font-medium" data-id="element-841">
                  London, Ontario · Free parking available
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>;
}